import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useAccountCheckoutDetails = ({
  accountId
}: {
  accountId: string;
}) => {
  const axios = useAxios();
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["account-checkout-details", accountId],
    queryFn: async () => {
      const urlKey = t("account-checkout-details");
      const response = await axios.get(urlKey + "/" + accountId);
      return response.data.data;
    },
    refetchOnWindowFocus: false
  });
};
